import { _ as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers-ded08042.js';
import styled from '@appbaseio/vue-emotion';

var _templateObject;
var Container = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.component;
});

export { Container as C };
